/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import axios from "axios";
import { Badge, Dropdown } from "react-bootstrap";
import { Link } from "react-router-dom";
import swal from "sweetalert";
import config from "../../../../config.json";
import "../../../i18n";
import { useTranslation } from "react-i18next";

const ItemsHistory = ({
  item,
  fetchItems,
  selected = false,
  onToggleSelect,
}) => {
  const { t } = useTranslation();
  const {
    // name,
    _id,
    photo,
    itemDetails = [],
    price,
    isArchived,
  } = item;

  const restoreItem = async () => {
    try {
      await axios.put(`${config.dev}/v2/items/restore/${_id}`).then(() => {
        swal(t("successTitle"), t("itemIsActivated"), t("success"));
      });
      fetchItems();
    } catch (error) {
      swal(t("errorTitle"), "" + error, t("error"));
    }
  };
  const deleteItemForever = async () => {
    const ok = await swal({
      title: t("areYouSure") || "Are you sure?",
      text: t("deleteForeverWarning") || "This action cannot be undone.",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    });
    if (!ok) return;
    try {
      await axios.delete(`${config.dev}/v2/items/delete/${_id}`);
      swal(t("successTitle"), t("deletedSuccessfully") || "Deleted permanently", t("success"));
      fetchItems();
    } catch (error) {
      swal(t("errorTitle"), error?.response?.data?.message || "" + error, t("error"));
    }
  };
  if (!isArchived) return null;

  return (
    <div className="col-xl-3 col-lg-4 col-md-6 col-sm-6 mb-4">
      <div className="card">
        <div className="card-body">
          <div className="d-flex justify-content-start mb-2">
            <input
              type="checkbox"
              className="form-check-input"
              checked={selected}
              onChange={(e) => onToggleSelect?.(_id, e.target.checked)}
            />
          </div>
          <div className="new-arrival-product">
            <div className="d-flex justify-content-end">
              <div className="basic-dropdown">
                <Dropdown>
                  <Dropdown.Toggle
                    as="button"
                    variant=""
                    className="btn sharp btn-primary tp-btn mt-1"
                    id="tp-btn"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      xmlnsXlink="http://www.w3.org/1999/xlink"
                      width="18px"
                      height="18px"
                      viewBox="0 0 24 24"
                      version="1.1"
                    >
                      <g
                        stroke="none"
                        strokeWidth="1"
                        fill="none"
                        fillRule="evenodd"
                      >
                        <rect x="0" y="0" width="24" height="24" />
                        <circle fill="#000000" cx="12" cy="5" r="2" />
                        <circle fill="#000000" cx="12" cy="12" r="2" />
                        <circle fill="#000000" cx="12" cy="19" r="2" />
                      </g>
                    </svg>
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Dropdown.Item as={Link} to={`/item-details/${_id}`}>
                      <i className="fa fa-eye me-2"></i>
                      {t("details")}
                    </Dropdown.Item>

                    <Dropdown.Item
                      onClick={() => {
                        restoreItem();
                      }}
                    >
                      <i className="fa fa-archive me-2"></i>
                      {t("restore")}{" "}
                    </Dropdown.Item>
                    <Dropdown.Item onClick={deleteItemForever}>
                      <i className="fa fa-trash me-2 text-danger"></i>
                      {t("deleteForever") || "Delete forever"}
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              </div>
            </div>
            <div className="new-arrivals-img-contnent">
              <img
                className="img-fluid"
                src={`${config.UPLOADS_SERVER}/product/${photo}`}
                alt={"Image-Preview"}
                style={{
                  height: "200px",
                  objectFit: "cover",
                  borderRadius: "8px",
                }}
              />
            </div>
            {/* Contenu du produit */}
            <div className="new-arrival-content text-center mt-3">
              <h4>
                <Link to="#" className="text-black">
                  {itemDetails.map((item) =>
                    item.language === "en" ? item.itemTitle : null
                  )}
                </Link>
              </h4>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ItemsHistory;
